import React, { Suspense } from "react";
import type { PropsWithChildren } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ThemeSpinner from "@/components/ThemeSpinner";
import { useNavigationType, useLocation } from "react-router-dom";
import "./index.css";

let needAnimation = true;

const ANIMATION_MAP = {
  PUSH: "forward",
  POP: "back",
  REPLACE: "forward",
};

const delayReset = () => {
  setTimeout(() => {
    needAnimation = true;
  }, 16);
};

window.addEventListener("touchstart", () => {
  needAnimation = true;
});

window.addEventListener("touchmove", () => {
  needAnimation = false;
});

window.addEventListener("touchend", delayReset);

const AnimationProvider = (props: PropsWithChildren) => {
  const location = useLocation();

  const navigationType = useNavigationType();

  return (
    <TransitionGroup
      className="router-wrapper"
      childFactory={(child) =>
        React.cloneElement(child, {
          classNames: needAnimation ? ANIMATION_MAP[navigationType] : "",
        })
      }
    >
      <CSSTransition timeout={300} key={location.key}>
        <div>
          <Suspense fallback={<ThemeSpinner />}>{props.children}</Suspense>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};
export default AnimationProvider;
